import React from 'react'
import { Link } from 'react-router-dom';
import './Servicebox.css'
import img1 from '../../assets/others/11102064.png'
import img2 from '../../assets/others/11102065.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Servicebox = () => {
  return (
    <div class="service-section ws-section">
        <div class="container text-center">
            <div class="row">
                <div class="col-lg-12">
                    <h2 class="ws-section_heading pd-010"> VLSI Training and Certification</h2>
                </div>
            </div>
            <div class="row align-items-center gx-5">
                <div class="col-lg">
                    <div class="service-box fresher mb-4">
                        <div class="row">
                            <div class="col-lg-4 box-img align-self-end">
                            <img src={img1} alt=''/>
                             </div>
                            <div class="col-lg-8 box-content p-4 d-flex flex-column justify-content-between">
                            <h4>VLSI Training for freshers</h4>
                            <p class="p-2">Join our VLSI training program designed specifically for freshers to kickstart your career in semiconductor design. Gain hands-on experience and industry-relevant skills to excel in the world of VLSI technology.</p>
                             <a href="/product-category/vlsi-courses-for-freshers/">
                                <button class="btn-secondary btn-icon btn-outline btn-small">Explore Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                           </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg">
                <div class="service-box pro mb-4">
                        <div class="row">
                            <div class="col-lg-8 box-content p-4 d-flex flex-column justify-content-between">
                            <h4>Free Webinar for Academic Industry</h4>
                            <p class="p-2">Join our free webinar to bridge the gap between academia and industry, offering valuable insights and trends. Gain expert knowledge to enhance your career and academic growth in the ever-evolving industry landscape.</p>
                             <a href="/academic/">
                                <button class="btn-secondary btn-icon btn-outline btn-small">Explore Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                </a>
                            </div>
                            <div class="col-lg-4 box-img align-self-end">
                            <img src={img2} alt=''/>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Servicebox